import { Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import IConfigService  from "fs-pb-vue2/services/config/IConfigService";
import { ShowcasePageData } from "fs-pb-vue2/data/showcasePageData";
import { ShowcaseData } from "fs-pb-vue2/data/showcaseData";
import { ShowCaseActionType } from "fs-pb-vue2/data/enums/showCaseActionType";
import { container } from "@/inversify.config";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { ConfigStore } from "fs-pb-vue2/store/modules/config";

export class ShowcaseVueGB extends Vue {

  @Watch("configStore.apiData.ShowcaseFile", { immediate: true })
  async onShowcaseFileChanged(newVal: string, oldVal: string) {
    if (newVal !== oldVal) {
      await this.getShowcase();
      if (this.$route.params.pageId && this.showcaseList.length > 0) {
        if (this.$route.params.pageId === 'calc' && !!this.$route.query.id) {
          this.selectedPage = this.showcaseList.find((page: ShowcasePageData) => page.Id.toString() === this.$route.query.id);
        } else {
          this.selectedPage = this.showcaseList.find((page: ShowcasePageData) => page.Id.toString() === this.$route.params.pageId);
        }
      }
    }
  }

  execLoading: boolean = false;

  showcaseList: Array<ShowcasePageData> = [];

  creditDataList: Array<any> = [];

  selectedPage: ShowcasePageData = null;

  sumValue: number = 0;

  depositFilter: any = {
    sumValue: 0,
    periodValue: '',
    draftValue: false,
    depositValue: false
  }

  periodArr: Array<any> = [
    {
      label: '1 мес.',
      value: 31
    },
    {
      label: '3 мес.',
      value: 91
    },
    {
      label: '6 мес.',
      value: 181
    },
    {
      label: '1 год',
      value: 365
    },
    {
      label: '2 года',
      value: 730
    },
    {
      label: '3 года',
      value: 1097
    },
    {
      label: '5 лет',
      value: 1830
    },
    {
      label: 'Ввести срок',
      value: ''
    }
  ];

  async refreshDepoList(): Promise<void> {
    this.execLoading = true;
    await this.$refs.ShowCaseDepositsList.refreshList(this.depositFilter);
    this.execLoading = false;
  }
   
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  get ConfigService(): IConfigService {
    return container.get<IConfigService>(DiTokens.ConfigService);
  }

  get showcaseListMain(): Array<any> {
    return this.showcaseList.filter((item: ShowcasePageData) => item.isRoot);
  }

  get filteredShowcaseItems(): (items: ShowcaseData[]) => ShowcaseData[] {
    return (items: ShowcaseData[]) => {
      if (!!items && items.length)
        return items.filter(item => item.EnableWeb);
      return [];
    };
  }

  get showcaseTypeName(): string {
    if (!this.selectedPage)
      return '';
    let typeName: string = '';
    if (this.$route.params.pageId !== 'calc' && this.selectedPage.Id !== this.showcaseList.find((page: ShowcasePageData) => page.Id.toString() === this.$route.params.pageId).Id) {
      this.selectedPage = this.showcaseList.find((page: ShowcasePageData) => page.Id.toString() === this.$route.params.pageId);
    }
    switch (this.selectedPage.Type) {
      case "depositSelection":
      case "deposits":
        typeName = 'ShowCaseDepositsList'
        break;
      case 'credit': {
        if (this.$route.path === '/showcase/calc')
          typeName = 'ShowCaseCreditCalc'
        else 
          typeName = 'ShowCaseCreditsList'
        break;
      }
      case 'tileList':
        typeName = 'ShowCaseTypesList'
        break;
      default:
        console.log('def');
        break;
    }
    return typeName;
  }

  async getShowcase(): Promise<void> {
    this.showcaseList = await this.ConfigService.fetchShowcase(this.configStore.apiData.ShowcaseFile);
    if (this.showcaseList.length) {
      this.creditDataList = [];
      this.showcaseList.map((page: ShowcasePageData) => {
        if (page.Type === 'credit')
          this.creditDataList.push(page);
      })
    }
  }

  callAction(item: ShowcaseData): void {
    if (item) {
      switch (item.ActionType) {
        case ShowCaseActionType.Close:
          console.log('Close action');
          break;
        case ShowCaseActionType.OpenLinkInApp:
          this.$router.push(`${item.ActionLink}`)
          break;
        case ShowCaseActionType.OpenLinkInBrowser:
          window.open(this.$options.filters.url(item.ActionLink), '_blank');
          break;
        case ShowCaseActionType.DownloadFile: {
          const link = document.createElement("a");
          link.href = this.$options.filters.url(item.ActionLink);
          link.download = item.ActionLink.substring(item.ActionLink.lastIndexOf('/'));
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          break;
        }
        default:
          console.log('None action');
          break;
      }
    }
  }
}
